import fileDownload from 'js-file-download';
import { axiosInstance } from '../axiosInstance';

const useSerialDownloads = (productId: string, productName: string, serialNumber: string) => {
  const getCsv = async (type: string) => {
    try {
      const response: any = await axiosInstance.get(
        `/products/${productId}/serialnumbers/${serialNumber}/download/${type}`
      );
      const { data } = response;
      fileDownload(data, `${productName.split(' ').join('_')}_${serialNumber}_${type}.csv`);
    } catch (e) {
      //TODO handle errors
    }
  };

  const downloadConfiguration = () => getCsv('configuration');
  const downloadHistory = () => getCsv('history');

  return { downloadConfiguration, downloadHistory };
};

const useDownloadPrintFile = (targets: Array<string>, format: string, size: string, properties: Array<number>, shortProperties: boolean, footer: string) => {
  const getFile = async () => {
    try {
      const response: any = await axiosInstance.post(
        '/print/serialnumbers',
        { targets: targets, format: format, size: size, properties: properties, short_properties: shortProperties, footer: footer },
        { responseType: 'blob' });

        const { data } = response;
        if (format === 'txt-zpl') {
          format = 'txt'; // ZPL files in text format are simple txt files.
        }

        fileDownload(data, `labels-${size}.${format}`);
    } catch (e) {
      //TODO handle errors
    }
  }

  return { getFile };
}

export { useSerialDownloads };
export { useDownloadPrintFile };